import { useState } from 'react';
import { ButtonSlim, ButtonLink } from '../../buttons';
import { ContactFormStyled, Select, Label, Title, Textarea } from './styledComponents';
// Default contact message subjects
var DEFAULT_SUBJECT_OPTIONS = [
    { id: 'ProductQuestion', text: 'Product Question' },
    { id: 'MyCalixStoreSupport', text: 'My Calix Store Support' },
    { id: 'Other', text: 'Other' },
];
export var ContactForm = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Use this form to communicate with your Customer Operations Representative' : _b, _c = _a.subjectOptions, subjectOptions = _c === void 0 ? DEFAULT_SUBJECT_OPTIONS : _c, onSubmit = _a.onSubmit, onClose = _a.onClose;
    var _d = useState(subjectOptions[0].id), subject = _d[0], setSubject = _d[1];
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    var handleSendClick = function () {
        onSubmit({ subject: subject, message: message });
        setSubject(subjectOptions[0].id);
        setMessage('');
    };
    return (<ContactFormStyled data-testid="contact-form">
      <Title>{title}</Title>
      <div>
        <Label>Subject</Label>
        <Select data-testid="contact-question-type" onChange={function (_a) {
        var target = _a.target;
        return setSubject(target.value);
    }}>
          {subjectOptions.map(function (option) { return (<option key={option.id} value={option.id}>
              {option.text}
            </option>); })}
        </Select>
        <Label>Message</Label>
        <Textarea data-testid="contact-message" onChange={function (_a) {
        var target = _a.target;
        return setMessage(target.value);
    }}/>
        <ButtonSlim data-testid="contact-send-btn" onClick={handleSendClick}>
          SEND
        </ButtonSlim>
        <ButtonLink data-testid="contact-cancel-btn" onClick={onClose}>
          CANCEL
        </ButtonLink>
      </div>
    </ContactFormStyled>);
};
